export interface GlossaryEntry {
  source: string;
  zhCN: string | null;
  status: 'official' | 'keep-english';
  sourceRef?: string;
  verifiedAt?: string;
  note?: string;
  explanation?: string;
}

const steam =
  'https://store.steampowered.com/app/3669870/CONTROL_Resonant/?l=schinese';
export const glossary: GlossaryEntry[] = [
  ...[
    ['CONTROL Resonant', '控制: 共振'],
    ['Dylan Faden', '迪伦·法登'],
    ['Jesse Faden', '杰西·法登'],
    ['Federal Bureau of Control', '联邦控制局（FBC）'],
    ['Aberrant', '异变者'],
  ].map(
    ([source, zhCN]): GlossaryEntry => ({
      source,
      zhCN,
      status: 'official',
      sourceRef: steam,
      verifiedAt: '2026-10-08',
    })
  ),
  ...[
    'Artist',
    'Dancer',
    'Deserter',
    'Collective',
    'Physicist',
    'Barrage',
    'Volatile Anomaly',
    'Shield',
    'Ground Slam',
    'Push',
    'Ignite',
    'Inferno',
    'Spore Burst',
    'Growth',
    'Spike',
    'Astral Rebuke',
    'Command',
    'Build Power',
    'Falter',
    'Astralized',
    'Loadout',
    'Pope’s Research',
    'Resonant Combat Token',
    'The Gap',
    'Mural',
    'Reset Item',
    'Contain the Crisis',
    'Arish’s Briefing',
    'Reroute Perimeter Station',
    'Reroute Factory Station',
    'Reroute East Park Station',
    'Reroute Vanished Station',
    'Calibrate Platform A',
    'Calibrate Platform B',
    'Probe Relays',
    'Follow the Music',
  ].map(
    (source): GlossaryEntry => ({
      source,
      zhCN: null,
      ...(source === 'Build Power' ? { explanation: '配装整体强度' } : {}),
      status: 'keep-english',
      note: 'Pending verification against in-game Simplified Chinese UI; explanations are not official names.',
    })
  ),
];

export function chineseTerm(source: string) {
  const entry = glossary.find((entry) => entry.source === source);
  return entry?.status === 'official' ? entry.zhCN || source : source;
}
